'use client'
import React from 'react'
import dynamic from 'next/dynamic'
import type { FooterProps } from '@/types/layout'
import { useEffect, useState, useCallback } from 'react'

const FooterLinks = dynamic(() => import('../footer/FooterLinks'))
const FooterBottom = dynamic(() => import('../footer/FooterBottom'))

const Footer = React.memo(function Footer({ footer, locales }: FooterProps) {
  const [showListLocalesValue, setShowListLocalesValue] = useState(false)

  // Memoized click handler — ignore clicks inside the switcher itself so the
  // native body listener does not race React's toggle (open then immediately close).
  const handleBodyClick = useCallback((event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target.closest('#localeList') || target.closest('[data-locale-switcher]')) {
      return
    }
    setShowListLocalesValue(false)
  }, [])

  useEffect(() => {
    document.body.addEventListener('click', handleBodyClick)
    return () => {
      document.body.removeEventListener('click', handleBodyClick)
    }
  }, [handleBodyClick])

  return (
    <footer className="relative z-50 bg-primary-ink-100 pb-11 pt-20 lg:pt-[120px]">
      <div className="container-fluid">
        <FooterLinks
          data={footer.data}
          locales={locales}
          showListLocalesValue={showListLocalesValue}
          onSetShowListLocalesValue={setShowListLocalesValue}
        />

        <FooterBottom data={footer.data} />
      </div>
    </footer>
  )
})

export default Footer
